// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '2px 8px',
          '&.Mui-selected': {
            color: theme.vars.palette.primary.main,
            backgroundColor: theme.vars.palette.primary.lighter,
            borderLeft: `5px solid ${theme.vars.palette.primary.main}`,
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.primary.main
            },
            '&:hover': {
              backgroundColor: theme.vars.palette.primary.lighter
            }
          }
        }
      }
    }
  };
}
